var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tcdc-custom-marker",style:({ 'background-color': _vm.color ? _vm.color : '#2e8037' })},[_c('div',{staticClass:"tcdc-bounce1",style:({ 'background-color': _vm.bounceColor ? _vm.bounceColor : '#2e8037' })}),_c('div',{staticClass:"tcdc-bounce2",style:({ 'background-color': _vm.bounceColor ? _vm.bounceColor : '#2e8037' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }